<template>
  <div>
      <ToolBar
        :handleToolSide="handleToolSide"
        :handleToolHeadBtn="handleToolHeadBtn"
        :title="title"
        :toolbarIcon="toolbarIcon"
        :toolbarColor="toolbarColor"
        :isLoading="isLoading"
      >
      <v-spacer></v-spacer>
      </ToolBar>

      <v-container fluid grid-list-md>
        <v-layout row wrap>
            <v-flex md4>
              <PieChart title="Parc" :data="parcStats"/>
            </v-flex>
            <v-flex md4>
              <PieChart title="Occupation" :data="occupationStats"/>
            </v-flex>
            <v-flex md4>
              <PieChart title="Reservations" :data="bookingStats"/>
            </v-flex>
            <v-flex md12>
              <StackedChart title="Affichage" :data="displayStats"/>
            </v-flex>
            <v-flex md12>
              <StackedChart title="Impressions (m²)" :data="printStats"/>
            </v-flex>
            <v-flex md6>
              <BarChart title="Interventions (intervenant)" :data="userStats"/>
            </v-flex>
            <v-flex md6>
              <BarChart title="Incidents" :data="incidentStats"/>
            </v-flex>
        </v-layout>
      </v-container>
  </div>
</template>

<script>
import ToolBar from '@/components/ToolBar'
import PieChart from '@/components/widgets/PieChart'
import BarChart from '@/components/widgets/BarChart'
import LineChart from '@/components/widgets/LineChart'
import StackedChart from '@/components/widgets/StackedChart'
import { accumulate } from '@/utils'
export default {
  components: {
    ToolBar,
    PieChart,
    BarChart,
    LineChart,
    StackedChart,
  },
  data: () => ({
    toolbarColor: 'green darken-2',
    toolbarIcon: 'home',
    title: 'Statistiques',
  }),
  methods: {
    handleToolSide () {
      let payload = {
        accessors: {},
        context: this.listContext,
        data: {},
      }
      this.$store.dispatch('ui/toggleDrawer', payload)
    },
    handleToolHeadBtn () {
      this.$router.push({path: '/'})
    },
  },
  computed: {
    isLoading () { return this.$store.getters['stats/isLoading'] },
    displayStats () { return this.$store.getters['stats/displays'] },
    printStats () { return this.$store.getters['stats/print'] },
    parcStats () { return accumulate(this.$store.getters['stats/parc']) },
    occupationStats () { return accumulate(this.$store.getters['stats/faces']) },
    bookingStats () { return accumulate(this.$store.getters['stats/bookings']) },
    userStats () { return accumulate(this.$store.getters['stats/interventions']) },
    incidentStats () { return accumulate(this.$store.getters['stats/incidents']) },
  },
  beforeMount () {
    this.$store.dispatch('stats/getStats')
  },
}
</script>
